export interface IChatPromptPayload {
    balance_data: IBalanceChartAssistantData;
    question: string;
}

export interface IBalanceChartAssistantData {
    candidates: IBalanceCandidate[];
    situation: IBalanceSituation | null;
}

export interface IBalanceCandidate {
    name: string;
    role: string;
    size: number;
    x: number;
    y: number;
}

export interface IBalanceSituation {
    value_crystallisation_depth: number;
    value_crystallisation_breadth: number;
    acquisitions_tactical: number;
    acquisitions_strategic: number;
    digitisation: number;
    operational_effectiveness: number;
    organic_revenue_growth: number;
    sales_transformation: number;
}

export interface IChatAnswerParams {
    payload: IChatPromptPayload;
    queryStrings: {
        project_insight_id: string;
    };
    onAnswerChunk: (chunk: string) => void;
    signal?: AbortSignal;
}

export const AI_HEALTH_STATUS = {
    good: "ONLINE_GOOD",
    unhealthy: "ONLINE_UNHEALTHY",
    offline: "OFFLINE",
} as const;

export interface IAIHealthResponse {
    health: {
        status: typeof AI_HEALTH_STATUS[keyof typeof AI_HEALTH_STATUS];
        msg: string;
    };
}
